"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = void 0;
const actions_1 = require("./actions");
const address_1 = require("./reducers/address");
const autoselectProvider_1 = require("./reducers/autoselectProvider");
const fiatValue_1 = require("./reducers/fiatValue");
const geoCurrency_1 = require("./reducers/geoCurrency");
const geoLocation_1 = require("./reducers/geoLocation");
const provider_1 = require("./reducers/provider");
const selectedCrypto_1 = require("./reducers/selectedCrypto");
const selectedFiat_1 = require("./reducers/selectedFiat");
const store_1 = require("./store");
const debug_1 = require("./reducers/debug");
const cryptoValue_1 = require("./reducers/cryptoValue");
const reducer = (state, action) => {
    switch (action.type) {
        case actions_1.CONTEXT_ACTIONS.SET_AUTOSELECT_PROVIDER:
            return (0, autoselectProvider_1.autoselectProviderReducer)(state, action.payload);
        case actions_1.CONTEXT_ACTIONS.SET_FIAT_VALUE:
            return (0, fiatValue_1.fiatValueReducer)(state, action.payload);
        case actions_1.CONTEXT_ACTIONS.SET_SELECTED_FIAT:
            return (0, selectedFiat_1.selectedFiatReducer)(state, action.payload);
        case actions_1.CONTEXT_ACTIONS.SET_CRYPTO_VALUE:
            return (0, cryptoValue_1.cryptoValueReducer)(state, action.payload);
        case actions_1.CONTEXT_ACTIONS.SET_SELECTED_CRYPTO:
            return (0, selectedCrypto_1.selectedCryptoReducer)(state, action.payload);
        case actions_1.CONTEXT_ACTIONS.SET_GEO_LOCATION:
            return (0, geoLocation_1.geoLocationReducer)(state, action.payload);
        case actions_1.CONTEXT_ACTIONS.SET_GEO_CURRENCY:
            return (0, geoCurrency_1.geoCurrencyReducer)(state, action.payload);
        case actions_1.CONTEXT_ACTIONS.SET_PROVIDER:
            return (0, provider_1.providerReducer)(state, action.payload);
        case actions_1.CONTEXT_ACTIONS.SET_ADDRESS:
            return (0, address_1.addressReducer)(state, action.payload);
        case actions_1.CONTEXT_ACTIONS.SET_DEBUG_OPTIONS:
            return (0, debug_1.debugOptionsReducer)(state, action.payload);
        case actions_1.CONTEXT_ACTIONS.TOGGLE_DEBUG:
            return (0, debug_1.toggleDebugReducer)(state);
        case actions_1.CONTEXT_ACTIONS.RESET_STATE:
            return store_1.INITIAL_STATE;
        default:
            return state;
    }
};
exports.reducer = reducer;
//# sourceMappingURL=reducer.js.map